var DEFAULT_YEARS_BACK = 100;
var DEFAULT_YEARS_FORWARD = 10;

/**
 * Builds the descending year list for the year dropdown, derived from the
 * min/max bounds when provided and otherwise a window around the current year.
 */
export function buildYearOptions(minDate, maxDate) {
  var now = new Date().getFullYear();
  var minYear = minDate ? minDate.getFullYear() : Math.min(maxDate ? maxDate.getFullYear() : now, now) - DEFAULT_YEARS_BACK;
  var maxYear = maxDate ? maxDate.getFullYear() : Math.max(minDate ? minDate.getFullYear() : now, now) + DEFAULT_YEARS_FORWARD;
  var from = Math.min(minYear, maxYear);
  var to = Math.max(minYear, maxYear);
  var options = [];
  for (var year = to; year >= from; year -= 1) {
    options.push({
      value: String(year),
      label: String(year)
    });
  }
  return options;
}